import React from 'react'
import { array, bool, string } from 'prop-types'
import { getIconCategory, SelectedItemCtx } from 'utils/searchUtils'

import SearchResultsCategory from 'components/atoms/SearchResultsCategory'
import SearchResultsItem from 'components/atoms/SearchResultsItem'

const SearchResultsGroup = ({ category, results, isNewSearch }) => {
  const categoryData = getIconCategory(category)
  return (
    <div className="search__results-group">
      <SearchResultsCategory isNewSearch={isNewSearch} {...categoryData}/>
      <ul className="search__results-list">
        {
          results.map((result, idx) => (
            <SelectedItemCtx.Consumer key={`${result.id}-${idx}`}>
              {
                selectedItem => (
                  <SearchResultsItem
                    onClick={() => selectedItem.handleSelect(result.id)}
                    active={result.id === selectedItem.id}
                    {...result}
                  />
                )
              }
            </SelectedItemCtx.Consumer>
          ))
        }
      </ul>
      <style jsx>
        {`
          .search__results-group {
            margin: 12px 0;
          }
          .search__results-list {
            list-style-type: none;
            padding: 0;
          }
        `}
      </style>
    </div>
  )
}

SearchResultsGroup.propTypes = {
  category: string,
  results: array,
  isNewSearch: bool,
}

SearchResultsGroup.defaultProps = {
  isNewSearch: false,
}

export default SearchResultsGroup
